import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './oem_home.routes';

import DistStockService from '../../components/api/dist_stock/dist_stock.service';
import ServiceStockService from '../../components/api/service_stock/service_stock.service';
import DeviceErrorService from '../../components/api/device_error/device_error.service';
import AnnounceService from '../../components/api/announce/announce.service';
import EventService from '../../components/api/event/event.service';
import CsvUtil from '../../components/logic/csv_util/csv.util';

export class OemHomeController {
  /*@ngInject*/
  constructor($filter, $interval, $mdDialog, CsvUtil, DistStockService, ServiceStockService, DeviceErrorService, AnnounceService, EventService) {
    this.DistStockService = DistStockService;
    this.ServiceStockService = ServiceStockService;
    this.DeviceErrorService = DeviceErrorService;
    this.AnnounceService = AnnounceService;
    this.EventService = EventService;
    this.CsvUtil = CsvUtil;
    this.$filter = $filter;
    this.$interval = $interval;
    this.$mdDialog = $mdDialog;

    this.announces = [];
    this.errorList = [];
    this.correctList = [];
    this.pagination = {};
    this.downloadFileName = 'event.csv';
  }

  $onInit() {
    this.DistStockService.oem_api.count(response => {
      this.deviceStockCount = response.tsw + response.tss;
    });

    this.ServiceStockService.oem_api.count(response => {
      this.serviceStockCount = response.dss + response.dsc;
    });

    this.updateEvents();
    this.updateDeviceError();

    this.AnnounceService.oem_api.index(response => {
      this.announces = response;
    });

    this.timer = this.$interval(() => {
      this.updateEvents();
      this.updateDeviceError(this.pagination.current_page);
    }, 30000);
  }

  changePage(page) {
    this.updateDeviceError(page);
  }

  updateEvents() {
    this.EventService.oem_api.index(response => {
      this.events = response;
      this.eventCsv = this.CsvUtil.processOemEvent(this.events);
    });
  }

  updateDeviceError(page=1) {
    this.DeviceErrorService.oem_api.index({ page: page }, response => {
      const list = response.device_errors;
      this.pagination = response.pagination;
      this.errorList = this.$filter("filter")(list, {has_error: true});
      this.correctList = this.$filter("filter")(list, {has_error: false});
    });
  }

  $onDestroy() {
    if (this.timer) {
      this.$interval.cancel(this.timer);
    }
  }

  isReadingDevice(device) {
    return device.operating_mode === 'reading';
  }

  isExpiredAnnounce(announce) {
    let announce_end = Date.parse(announce.end_at);
    let now = Date.now();
    return announce_end < now;
  }

  showDialog(announce, ev) {
    this.AnnounceService.oem_api.show({id: announce.id}, (announce) => {
      this.$mdDialog.show({
        targetEvent: ev,
        templateUrl: 'announce-dialog-oem.html',
        controller: DialogController,
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        fullscreen: false,
        locals: {
          announce: announce
        }
      });

      /*@ngInject*/
      function DialogController($scope, $mdDialog, announce) {
        $scope.announce = announce;

        $scope.closeDialog = function () {
          $mdDialog.hide();
        };
      }
    }, (response) => {
      let alert = this.$mdDialog.alert()
        .title('エラー')
        .textContent('障害・メンテナンス情報を取得できませんでした')
        .ok('閉じる');
      this.$mdDialog.show(alert);
    });
  }
}

export default angular.module('leptonApp.oemHome', [uiRouter, DistStockService, ServiceStockService, DeviceErrorService, AnnounceService, EventService, CsvUtil])
  .config(routing)
  .component('oemHome', {
    template: require('./oem_home.html'),
    controller: OemHomeController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/oem_home/oem_home.component.js